import React, { Component } from "react";
import styled from "styled-components";
class ContentHeader extends Component {
  render() {
    return (
      <Container>
        <Title>{this.props.title}</Title>
        <Description>{this.props.description}</Description>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  background: rgba(253, 186, 3, 0.85);
  margin: 0 0 10px 0;
  @media only screen and (max-width: 980px) {
    width: initial;
    margin: 0 5px 10px 5px;
    padding: 5px 10px 10px 10px;
    display: block;
  }
`;

const Title = styled.h1`
  padding: 0 5px 0 10px;
  margin: 0;
  font-size: 2rem;
  @media only screen and (max-width: 980px) {
    padding: 0;
    font-size: 1.6rem;
  }
`;

const Description = styled.p`
  padding: 0 5px 10px 10px;
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 0.8rem;
  @media only screen and (max-width: 980px) {
    margin: 0;
    padding: 0;
  }
`;

export default ContentHeader;



// WEBPACK FOOTER //
// ./src/components/layout/ContentHeader.js